// extracted by mini-css-extract-plugin
export default {"layout":"Home_layout__F6Xaw"};